import {
  STATUS_FILTER_LABELS,
  overrideLabels,
  resolveOrder,
  type ResourceStatus
} from '@/shared/lib/status'

export type PrizeUiStatus = ResourceStatus

/* Prêmio usa vocabulário de sorteio: quem está `progress` está "Participando",
   quem está `success` "Ganhei". São overrides de rótulo, não uma segunda tabela
   — chaves e ordem continuam vindo do canônico. */
export const PRIZE_STATUS_LABELS = overrideLabels({
  progress: 'Participando',
  locked: 'Não elegível',
  success: 'Ganhei'
})

/* Divergência declarada: prêmios exibem os ganhos PRIMEIRO, ao contrário do
   canônico, que põe concluídos depois dos disponíveis. É a única inversão, e
   cabe nesta linha em vez de virar uma tabela paralela. */
export const PRIZE_SORT_PRIORITY = resolveOrder({ success: -1 })

export type PrizeFilterId = 'all' | 'new' | ResourceStatus

const FILTER_LABELS = overrideLabels(
  {
    progress: 'Participando',
    locked: 'Não elegível',
    success: 'Ganhos'
  },
  STATUS_FILTER_LABELS
)

export const PRIZE_FILTERS: { id: PrizeFilterId; label: string }[] = [
  { id: 'all', label: 'Todos' },
  { id: 'progress', label: FILTER_LABELS.progress },
  { id: 'available', label: FILTER_LABELS.available },
  { id: 'locked', label: FILTER_LABELS.locked },
  { id: 'expired', label: FILTER_LABELS.expired },
  { id: 'success', label: FILTER_LABELS.success }
]
